import { useEffect, useState } from "react";
import Select from "react-select";
import axiosInstance from "../../../axiosInterceptor";
const CheckboxOption = ({ data, innerRef, innerProps, selectProps }) => {
  const isSelected = selectProps.value?.some(
    (v) => v.value === data.value
  );

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="d-flex align-items-center gap-2 p-2"
      style={{ cursor: "pointer" }}
    >
      <input type="checkbox" checked={isSelected} readOnly />
      <span>{data.label}</span>
    </div>
  );
};

const CollectionSelect = ({
  endPoint,
  parentId,
  value = [],
  onChange,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    axiosInstance.get("/collection").then((res) => {
      setOptions(
        (res.data.data || []).map((i) => ({
          value: i.id,
          label: i.name,
        }))
      );
    });
  }, []);

  const handleToggle = async (option) => {
    const exists = value.some((v) => v.value === option.value);

    let updatedValue;

    if (exists) {
      updatedValue = value.filter((v) => v.value !== option.value);
    } else {
      updatedValue = [...value, option];
    }

    try {
      setLoading(true);

      await axiosInstance.post(endPoint, {
        id: parentId,
        collection_id: option.value,
        action: exists ? "REMOVE" : "ADD", 
      });

      onChange?.(updatedValue);
    } catch (err) {
     return err
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      isMulti
      options={options}
      value={value}
      isLoading={loading}
      placeholder="Select Collection"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}

      controlShouldRenderValue={false} 
      components={{ Option: CheckboxOption }}
      onChange={(selected, meta) => {
        if (meta?.option) {
          handleToggle(meta.option);
        }
      }}

      styles={{
        control: (base) => ({
          ...base,
          minWidth: 350,
          minHeight: 48,
          borderRadius: 8,
        }),
      }}
    />
  );
};

export default CollectionSelect;
